import BankingService from 'services/Banking'
import MainButton from 'components/Buttons/MainButton'
import { FaArrowLeft } from 'react-icons/fa'

import {
  Container,
  Content,
  Card,
  CardTitle,
  Caption,
  BackRow,
  BackButton,
  OperationTitle,
  HeroCard,
  HeroLabel,
  HeroBalance,
  StatusBadge,
  Dot
} from '../styles'

/*
  A casca que todas as telas de operação do Cutilei Pay compartilham.

  Cada operação virou uma tela própria — Pix, boleto, saque, entre contas —, e todas
  precisam da mesma coisa antes de mostrar qualquer formulário: o saldo disponível no topo,
  a volta para onde se estava e a certeza de que a conta pode movimentar. Ficava tudo na aba
  de transferências; com a aba desfeita, ficaria repetido cinco vezes.

  O saldo vem por prop da página, que é quem lê a conta, e `onCompleted` manda recarregar —
  é o que mantém o topo honesto depois de um Pix.
*/
export default function BankingOperation ({
  account,
  title,
  onBack = () => {},
  onTabNavigate = () => {},
  children
}) {
  const renderHeader = () => (
    <BackRow>
      <BackButton type='button' aria-label='Voltar' onClick={onBack}>
        <FaArrowLeft size={13} color='#252525'/>
      </BackButton>
      <OperationTitle>{title}</OperationTitle>
    </BackRow>
  )

  /*
    Conta em análise não movimenta dinheiro. O formulário nem chega a ser montado: o Asaas
    recusaria a operação e o titular perderia o preenchimento à toa.
  */
  if (!account.canTransact) return (
    <Container>
      <Content>
        {renderHeader ()}
        <Card gap={12}>
          <StatusBadge color={BankingService.getStatusColor (account.status)}>
            <Dot/>
            {BankingService.getStatusLabel (account.status)}
          </StatusBadge>
          <CardTitle>Sua conta ainda não pode movimentar saldo</CardTitle>
          <Caption>
            {'Conclua a abertura da conta para liberar os saques e as transferências. '
            + 'Você será avisado assim que ela for aprovada'}
          </Caption>
          <MainButton
            label='Ver meus dados'
            onClick={() => onTabNavigate ('account_data')}
            width={180}
          />
        </Card>
      </Content>
    </Container>
  )

  const balance = Number (account.balance ?? 0)
  const availableBalance = Number (account.availableBalance ?? balance)

  /*
    A tarifa vem junto da conta, e não de uma rota própria: é o par que toda tela de operação
    precisa, e assim ela não custa uma requisição a mais. `null` é tarifa não carregada.
  */
  const pixFee = Number (account.pixFee ?? 0)

  return (
    <Container>
      <Content>
        {renderHeader ()}
        <HeroCard>
          <HeroLabel>Disponível para movimentar</HeroLabel>
          <HeroBalance value={availableBalance}/>
        </HeroCard>
        {children ({ availableBalance, pixFee })}
      </Content>
    </Container>
  )
}
